import { useMutation } from '@hooks/reactQuery';

import { checkUserEmail } from '@api/users';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { ICheckEmailAsPoDTO } from '@interfaces/user/dto/userDTO';
import { IUserCheckEmail } from '@interfaces/user/user';

import { EUserRoles } from '@enums/common';
import { EErrorCodes } from '@enums/errorCodes';

import { CHECK_EMAIL } from '@constants/queryKeys';

interface IUseMutateCheckEmailReturned {
	isLoadingCheckEmail: boolean;
	checkEmail: (dto: ICheckEmailAsPoDTO) => Promise<IUserCheckEmail>;
	checkEmailError?: string;
	resetCheckEmail: () => void;
	emailStatus?: IUserCheckEmail;
}

const useMutateCheckEmail = (): IUseMutateCheckEmailReturned => {
	const {
		isLoading,
		mutateAsync,
		error,
		reset,
		data,
	} = useMutation<ICheckEmailAsPoDTO, IUserCheckEmail, IResponseError>({
		mutationKey: [CHECK_EMAIL],
		mutationFn: checkUserEmail,
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => (
				item.code === EErrorCodes.uniqueName ||
				item.code === EErrorCodes.emailWrongFormat ||
				item.code === EErrorCodes.notValidNameLength ||
				item.code === EErrorCodes.templateNameMustBeSize
			))) {
				handleErrorFromMessage(err);
			}
		},
		allowedRoles: [
			EUserRoles.assetOwnerOrganizationAdministrator,
			EUserRoles.networkOperatorOrganizationAdministrator,
			EUserRoles.platformOwnerAdministrator,
			EUserRoles.assetConsumerOrganizationAdministrator,
		],
	});

	return {
		emailStatus: data,
		checkEmail: mutateAsync,
		resetCheckEmail: reset,
		checkEmailError: error?.errors?.map((item) => item.message).join(' ') || undefined,
		isLoadingCheckEmail: isLoading,
	};
};

export default useMutateCheckEmail;
